import type { Token } from '@/types';
import { env } from '@/utility';
import axios, { AxiosError } from 'axios';

export const getConfiguration = async (tenantUuid: string) => {
  try {
    const { data } = await axios.get(`${env.baseApiUrl}/tenants/${tenantUuid}/config`);

    return data;
  } catch (e) {
    const error = (e instanceof AxiosError && e?.response?.data) || e;
    const errorMessage = error?.message || `Unknown error`;

    console.error(e, error, errorMessage);

    return {
      error: true,
      message: errorMessage
    };
  }
};

export const login = async (token: Token, userId: string, tenantUuid: string) => {
  try {
    const { data } = await axios.get(
      `${env.baseApiUrl}/tenants/${tenantUuid}/users/${userId}/token`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return data;
  } catch (e) {
    const error = (e instanceof AxiosError && e?.response?.data) || e;
    const errorMessage = error?.message || `Unknown error`;

    console.error(e, error, `${errorMessage} token: ${token}`);

    return {
      error: true,
      message: errorMessage
    };
  }
};

export const logout = async (token: Token, userId: string, tenantUuid: string) => {
  try {
    const { data } = await axios.get(
      `${env.baseApiUrl}/tenants/${tenantUuid}/users/${userId}/logout`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return data;
  } catch (e) {
    const error = (e instanceof AxiosError && e?.response?.data) || e;
    const errorMessage = error?.message || `Unknown error`;

    console.error(e, error, `${errorMessage} token: ${token}`);

    return {
      error: true,
      message: errorMessage
    };
  }
};

export default { getConfiguration, login, logout };
